import { createIcon } from "@chakra-ui/react";

const MobaIcon = createIcon({
  displayName: "MobaIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M5 5V10L9 5H13V10L17 5H22V19H17V14L13 19H9V14L5 19H2V5H5Z"
      fill="currentColor"
    />
  ),
});

export default MobaIcon;
